(function () {
  const initSectionLayout = (section) => {
    if (!section || !section?.classList.contains("text-banner-section")) {
      return;
    }

    const setupMinHeight = (section) => {
      if (section.querySelector(".text-banner__heading") != null) {
        const tallest = [
          ...section.querySelectorAll(".text-banner__heading"),
        ].reduce((max, el) => (el.clientHeight > max.clientHeight ? el : max));

        section.style = `--min_height_text-banner: ${tallest.clientHeight}px`;
      }
    };

    const animateHeadings = (section, timeout = 2000) => {
      const headings = section.querySelectorAll(".text-banner__heading");
      if (!headings.length) return;

      let index = 0;
      headings.forEach((heading) => heading.classList.remove("active"));
      headings[index].classList.add("active");

      if (headings.length === 1) return;

      setInterval(() => {
        headings[index].classList.remove("active");
        index = (index + 1) % headings.length;
        headings[index].classList.add("active");
      }, timeout);
    };

    const configuredTimeout =
      Number(section.querySelector(".text-banner").dataset.timeout) * 1000;
    const isHomepageBrandBanner = section.id?.endsWith("__text_banner_bQLhVm");
    const timeout = isHomepageBrandBanner ? 3000 : configuredTimeout;

    setupMinHeight(section);
    animateHeadings(section, timeout);

    window.addEventListener("resize", () => {
      setTimeout(() => setupMinHeight(section), 500);
    });
  };

  initSectionLayout(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSectionLayout(event.target);
  });
})();
